import React from "react";
import { Button } from "./ui/button";
import { useLogout } from "../common/logout";
import Swal from "sweetalert2";

const LogoutBtn = ({ fullWidth = false }) => {
  const logout = useLogout();

  const handleLogout = () => {
    return Swal.fire({
      icon: "info",
      title: "로그아웃 하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "로그아웃",
      cancelButtonText: "취소",
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  };

  return (
    <Button
      variant="outline"
      onClick={handleLogout}
      className={`text-[15px] ${fullWidth ? "w-full" : ""}`}
    >
      로그아웃
    </Button>
  );
};

export default LogoutBtn;
